import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-4 py-10 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Logo & Description */}
          <div className="sm:col-span-2 lg:col-span-1 text-center sm:text-left">
            <img 
              src="https://static.readdy.ai/image/a17d3ae5e640a18a289681692364ae47/58da3f7e4785850c57041e6c71714363.png" 
              alt="PRT Proprete" 
              className="h-16 sm:h-20 w-auto mb-4 sm:mb-6 transform hover:scale-105 transition-transform duration-300 mx-auto sm:mx-0"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Préparateur auto professionnel à Creil. Service de qualité premium pour redonner tout son éclat à votre véhicule.
            </p>
          </div>

          {/* Navigation */}
          <div className="text-center sm:text-left">
            <h3 className="text-white font-black text-lg mb-4 sm:mb-6 flex items-center justify-center sm:justify-start">
              <i className="ri-menu-line text-[#00B4D8] mr-2"></i>
              Navigation
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#00B4D8] transition-colors duration-200 cursor-pointer flex items-center justify-center sm:justify-start group">
                  <i className="ri-arrow-right-s-line text-[#E63946] mr-2 transform group-hover:translate-x-1 transition-transform"></i>
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/prestations" className="text-gray-400 hover:text-[#00B4D8] transition-colors duration-200 cursor-pointer flex items-center justify-center sm:justify-start group">
                  <i className="ri-arrow-right-s-line text-[#E63946] mr-2 transform group-hover:translate-x-1 transition-transform"></i>
                  Nos Prestations
                </Link>
              </li>
              <li>
                <Link to="/confiance" className="text-gray-400 hover:text-[#00B4D8] transition-colors duration-200 cursor-pointer flex items-center justify-center sm:justify-start group">
                  <i className="ri-arrow-right-s-line text-[#E63946] mr-2 transform group-hover:translate-x-1 transition-transform"></i>
                  Pourquoi Nous ?
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#00B4D8] transition-colors duration-200 cursor-pointer flex items-center justify-center sm:justify-start group">
                  <i className="ri-arrow-right-s-line text-[#E63946] mr-2 transform group-hover:translate-x-1 transition-transform"></i>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left">
            <h3 className="text-white font-black text-lg mb-4 sm:mb-6 flex items-center justify-center sm:justify-start">
              <i className="ri-customer-service-line text-[#E63946] mr-2"></i>
              Contact
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start text-gray-400 group justify-center sm:justify-start">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-[#00B4D8]/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0 group-hover:bg-[#00B4D8]/30 transition-colors">
                  <i className="ri-phone-line text-[#00B4D8] text-sm sm:text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500 mb-1">Téléphone</div>
                  <a href="tel:0776969414" className="hover:text-[#00B4D8] transition-colors duration-200 cursor-pointer font-semibold text-sm sm:text-base">
                    07.76.96.94.14
                  </a>
                </div>
              </li>
              <li className="flex items-start text-gray-400 group justify-center sm:justify-start">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-[#E63946]/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0 group-hover:bg-[#E63946]/30 transition-colors">
                  <i className="ri-map-pin-line text-[#E63946] text-sm sm:text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500 mb-1">Localisation</div>
                  <span className="font-semibold text-sm sm:text-base">Creil (60)</span>
                </div>
              </li>
              <li className="flex items-start text-gray-400 justify-center sm:justify-start">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-[#00B4D8]/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-car-line text-[#00B4D8] text-sm sm:text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500 mb-1">Service</div>
                  <span className="text-xs sm:text-sm font-semibold">Déplacement gratuit 35km</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="text-center sm:text-left">
            <h3 className="text-white font-black text-lg mb-4 sm:mb-6 flex items-center justify-center sm:justify-start">
              <i className="ri-share-line text-[#00B4D8] mr-2"></i>
              Nos Réseaux
            </h3>
            <div className="space-y-3 sm:space-y-4">
              <a 
                href="https://www.snapchat.com/add/prtproprete?share_id=GYAE0Kf14bw&locale=fr-FR" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center text-gray-400 hover:text-[#FFFC00] transition-all duration-200 cursor-pointer group justify-center sm:justify-start"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#FFFC00]/20 to-[#FFFC00]/10 rounded-xl flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-snapchat-line text-[#FFFC00] text-xl sm:text-2xl"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500">Snapchat</div>
                  <span className="font-semibold text-sm sm:text-base">PRTPROPRETE</span>
                </div>
              </a>
              <a 
                href="https://www.instagram.com/prt.proprete/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center text-gray-400 hover:text-[#E4405F] transition-all duration-200 cursor-pointer group justify-center sm:justify-start"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#E4405F]/20 to-[#E4405F]/10 rounded-xl flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-instagram-line text-[#E4405F] text-xl sm:text-2xl"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500">Instagram</div>
                  <span className="font-semibold text-sm sm:text-base">prt.proprete</span>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-10 md:mt-12 pt-6 sm:pt-8 border-t border-gray-700 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-gray-400 text-xs sm:text-sm flex items-center">
            <i className="ri-copyright-line mr-2"></i>
            2025 PRT Proprete. Tous droits réservés.
          </p>
          <a 
            href="https://uzundigital.fr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 text-xs sm:text-sm hover:text-[#00B4D8] transition-colors duration-200 cursor-pointer flex items-center group"
          >
            <span>Webbuilder UzunDigital</span>
            <i className="ri-external-link-line ml-2 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}
